import {useEffect, useState} from "react";

const QUERY = "(max-width: 768px)";

export function useIsMobile(): boolean {
    const [matches, setMatches] = useState(() => window.matchMedia(QUERY).matches);
    useEffect(() => {
        const mq = window.matchMedia(QUERY);
        const onChange = () => setMatches(mq.matches);
        onChange();
        mq.addEventListener("change", onChange);
        return () => mq.removeEventListener("change", onChange);
    }, []);
    return matches;
}
